// AI Generated File
import { AfterViewInit, ChangeDetectorRef, Component, inject, Input } from '@angular/core';

@Component({
    selector: 'inventory-links-count',
    templateUrl: './links-count.component.html',
    standalone: false,
})
export class LinksCountComponent implements AfterViewInit {
    @Input() notificationList: any[] = [];
    @Input() panelHeaderTitle: string = '';
    screenWidth = 0;

    cdRef = inject(ChangeDetectorRef);

    ngAfterViewInit () {
        this.screenWidth = window.innerWidth;
        this.cdRef.detectChanges();
    }

    trackByIndex (index: number): number {
        return index;
    }
}
